export var PaneLayout;
(function (PaneLayout) {
    PaneLayout["TagSelection"] = "tag-selection";
    PaneLayout["ItemSelection"] = "item-selection";
    PaneLayout["TableView"] = "files-view";
    PaneLayout["Editing"] = "editing";
})(PaneLayout || (PaneLayout = {}));
